/**
 * Created by Karol Kluska on 21.06.17.
 */

angular
  .module('app')
  .component('numberPicker', {
    templateUrl: 'app/shared/numberPicker/NumberPicker.html',
    controller: NumberPicker,
    bindings: {
      min: '<?',
      max: '<?',
      number: '<',
      onUpdate: '&'
    }
  });

function NumberPicker() {}

NumberPicker.prototype = {
  $onInit: function () {
    this.min = parseInt(this.min, 10);
    this.max = parseInt(this.max, 10);
    this.number = parseInt(this.number, 10);
    if (this.min > this.max) {
      var tempMin = this.min;
      this.min = this.max;
      this.max = tempMin;
    }
    if (!this.isValidValue(this.number)) {
      if (!isNaN(this.min) || !isNaN(this.max)) {
        this.number = this.min || this.max;
      } else {
        this.number = 0;
      }
    }
  },

  decrease: function () {
    var newValue = this.number - 1;
    this.updateValue(newValue);
  },

  increase: function () {
    var newValue = this.number + 1;
    this.updateValue(newValue);
  },

  updateValue: function (newValue) {
    if (this.isValidValue(newValue)) {
      this.number = newValue;
      this.onUpdate({value: this.number});
    }
  },

  isValidValue: function (value) {
    var isGreaterThanMin = true;
    var isLowerThanMax = true;

    if (!isNaN(this.min)) {
      isGreaterThanMin = value >= this.min;
    }

    if (!isNaN(this.max)) {
      isLowerThanMax = value <= this.max;
    }

    return isGreaterThanMin && isLowerThanMax;
  }
};
